import React from 'react'
import DateInputBase from './DateInputBase'
import { int } from 'framer-motion/types/render/dom/value-types/type-int'

const MonthInput = (props) => {
    const isValid = (value) => {
        const v = typeof value === 'number' ? value : parseInt(value)

        if (v !== undefined) {
            return v <= 12 && v >= 0
        }
        return false
    }

    const handleChange = (setInternalValue, internalVal) => (e) => {
        const textVal = e.target.value
        // const textVal = (parseInt(e.target.value) - 1).toString()
        let val
        if (textVal === '') {
            setInternalValue(null)
            return
        } else {
            val = parseInt(e.target.value)

            if (!isValid(val)) {
                return
            }
        }

        if (textVal.length === props.format.length) {
            props.focusNextInput()
        }
        const i = internalVal
        setInternalValue((val - 1).toString())
    }

    //Set display value = +1 to accomodate js month starting at 0
    const value = props.value
    return (
        <DateInputBase
            {...props}
            value={value}
            displayValue={(internalVal) => {
                if (internalVal === null || internalVal === undefined) {
                    return ''
                }
                if (isNaN(internalVal)) {
                    return ''
                }
                return parseInt(internalVal) + 1
            }}
            placeholder={'MM'}
            handleInternalChange={handleChange}
            onChange={props.onChange}
            onBlur={(val, handleSetFinalValue, clearInput, zeroPadValue, priorValue) => {
                // const date = moment('01-01-' + val)
                let finalVal = null
                if (val !== undefined && val !== null) {
                    finalVal = !isValid(val) ? priorValue || 0 : val
                }
                handleSetFinalValue(finalVal)
            }}
        />
    )
}
export default MonthInput
